// anchor links
$(function () {
    // Anchor in URL
    const anchorId = location.hash.replace('#', '');
    if (anchorId.length > 0) {
        revealAnchorInAccordion(anchorId);
        // jump to anchor
        document.location.href = `#${anchorId}`;
    }

    // User clicks an anchor link
    $('a[href^="#"]').click(function () {
        // extract the ID of the anchor
        const anchorId = $(this).attr('href').split('#')[1];
        // stop of ID is blank, e.g. href="#"
        if (anchorId.length === 0) return;
        revealAnchorInAccordion(anchorId);
    });

    function revealAnchorInAccordion(anchorId) {
        // get the anchor element
        const $anchor = $(`#${anchorId}`);
        // is the anchor within an accordion?
        if ($anchor.parents('.uk-accordion-content').length > 0) {
            // is the accordion minimised?
            if (!$anchor.is(':visible')) {
                // expand the accordion item
                const $a = $('.accordion-block > ul');
                UIkit.accordion($a).toggle($anchor.parents('li').index(), false);
            }
        }

    }
});